'use client'

import Link from 'next/link'
import React from 'react'

import { useCarrello } from './CarrelloProvider.client'

/** Header cart link with the `#cartCount` badge. */
export const CartButton: React.FC = () => {
  const { articoli } = useCarrello()

  return (
    <Link
      aria-label={`Carrello, ${articoli} ${articoli === 1 ? 'articolo' : 'articoli'}`}
      className="cartbutton"
      href="/carrello"
    >
      <svg
        aria-hidden="true"
        fill="none"
        height="24"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        viewBox="0 0 24 24"
        width="24"
      >
        <path d="M3 4h2l2.4 11h11.2L21 7H6.2" />
        <circle cx="9" cy="20" r="1.5" />
        <circle cx="17" cy="20" r="1.5" />
      </svg>
      <span>Carrello</span> <span id="cartCount">{articoli}</span>
    </Link>
  )
}
